export default __webpack_public_path__ + "static/media/img-fullscreen-telefoni.323f9521.png";